/* global ActiveXObject */
let PST = PST || new function () {
    let conf,
        BASE_URL,
        lastBlock = 0,
        lastItem = 0,
        view = null,
        results = [],
        successFn = null,
        errorFn = null,
        id,
        lastClick = new Date().getTime(),
        retrys = 0,
        MAX_TRYS = 10,
        ajax = conf => {
            var xhr;
            if (typeof window.XMLHttpRequest !== 'undefined') {
                xhr = new XMLHttpRequest();
            } else if (typeof ActiveXObject !== 'undefined') {
                xhr = new ActiveXObject('Microsoft.XMLHTTP');
            }
            if (xhr) {
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            document.body.style.cursor = 'default';
                            let contentType = xhr.getResponseHeader('content-type').split(';')[0],
                                responseText = xhr.responseText,
                                data;
                            if (contentType === 'application/json') {
                                data = JSON.parse(responseText);
                            }
                            if (typeof conf.success === 'function') {
                                conf.success(data);
                            }
                            retrys = 0;
                        } else {
                            if (typeof conf.error === 'function' && xhr.status <= 500 && retrys < MAX_TRYS) {
                                setTimeout(function () {
                                    retrys++;
                                    ajax(conf);
                                }, 2000);
                            } else {
                                if (typeof conf.error === 'function' && (xhr.status !== 0 && xhr.status < 500)) {
                                    document.body.style.cursor = 'default';
                                    conf.error(xhr, xhr.status);
                                }
                                if (typeof conf.error === 'function' && (xhr.status === 0 || xhr.status >= 500) && retrys >= MAX_TRYS) {
                                    document.body.style.cursor = 'default';
                                    document.body.style.cursor = 'default';
                                    conf.error({
                                        code: 402,
                                        message: 'No connection to the server can be established at the moment. Please try again later.'
                                    }, 0);
                                }
                            }
                        }
                    }
                }

                if (typeof conf.error === 'function') {
                    xhr.onerror = conf.error;
                }

                xhr.open(conf.type, conf.url);

                for (var k in conf.headers) {
                    if (conf.headers.hasOwnProperty(k)) {
                        xhr.setRequestHeader(k, conf.headers[k]);
                    }
                }

                xhr.timeout = 2000;
                xhr.ontimeout = function () {
                    if (retrys < MAX_TRYS) {
                        ajax(conf);
                        retrys++;
                    }
                }

                if (conf.data) {
                    xhr.send(conf.data);
                } else {
                    xhr.send();
                }

            }
        },
        load = (locale, _successFn, _errorFn) => {
            ajax({
                type: 'GET',
                url: BASE_URL + '/pst/load/?locale=' + locale,
                success: data => {
                    conf = data;
                    if (_successFn) {
                        _successFn(200, 'success');
                    }
                },
                error: (xhr, status) => {
                    if (_errorFn) {
                        _errorFn(xhr, status);
                    }
                }
            });
        },
        calcResult = (_successFn, _errorFn) => {
            ajax({
                type: 'POST',
                url: BASE_URL + '/pst/calcResult',
                data: JSON.stringify(results),
                headers: {
                    id: id,
                    'Content-Type': 'application/json'
                },
                success: data => {
                    if (_successFn) {
                        _successFn(200, data);
                    }
                },
                error: (xhr, status) => {
                    if (_errorFn) {
                        _errorFn(xhr, status);
                    }
                }
            });
        },
        stripAndExecute = text => {
            let scripts = '',
                cleaned = text.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function () {
                    scripts += arguments[1] + '\n';
                    return '';
                });
            setTimeout(() => {
                if (window.execScript) {
                    try {
                        window.execScript(scripts);
                    } catch (e) {
                        window.eval(scripts);
                    }
                } else {
                    window.eval(scripts);
                }
            }, 50);
            return cleaned;

        },
        findIndex = (array, pattern) => {
            if (array.findIndex) {
                return array.findIndex(e => {
                    return e.id === pattern;
                })
            } else {
                for (var i = 0, len = array.length; i < len; i++) {
                    if (array[i].id === pattern) {
                        return i;
                    }
                }
                return -1;
            }
        },
        randomString = (len, an) => {
            an = an && an.toLowerCase();
            let str = "",
                i = 0,
                min = an == "a" ? 10 : 0,
                max = an == "n" ? 10 : 62;
            for (; i++ < len;) {
                let r = Math.random() * (max - min) + min << 0;
                str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
            }
            return str;
        };

    return {
        init(config) {
            view = document.getElementById(config.viewport);
            successFn = config.success;
            errorFn = config.error;
            id = config.id ? config.id : randomString(32);
            BASE_URL = config.baseUrl ? config.baseUrl : '';

            lastBlock = 0;
            lastItem = 0;
            results = [];

            view.style.position = 'relative';
            view.style.userSelect = 'none';

            if (id) {
                document.body.style.cursor = 'wait';
                document.body.style.cursor = 'wait';
                load(config.locale || navigator.language || navigator.userLanguage,
                    (status, message) => {
                        if (!!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect) === false) {
                            if (errorFn) {
                                errorFn({
                                    code: 399,
                                    message: conf.fallback
                                });
                            } else {
                                view.innerHTML = conf.fallback;
                            }
                        } else {
                            if (status === 200) {
                                view.innerHTML = conf.blocks[lastBlock].content;
                            } else {
                                if (errorFn) {
                                    errorFn({
                                        code: 401,
                                        message: message
                                    });
                                } else {
                                    view.innerHTML = '<b>ERROR</b></br><p>' + message + '</p>';
                                }
                            }
                        }
                    }, (xhr, status) => {
                        errorFn({
                            code: status,
                            message: xhr
                        });
                    });
            } else {
                if (errorFn) {
                    errorFn({
                        code: 400,
                        message: 'You must pass an unique test id!'
                    })
                } else {
                    view.innerHTML = '<b>ERROR</b></br><p>You must pass an unique test id!</p>';
                }
            }
        },
        nextItem(result) {
            var now = new Date().getTime();
            if (now - lastClick < 500) {
                return;
            }
            lastClick = now;
            if (result) {
                let idx = findIndex(results, result.id);
                if (idx !== -1) {
                    // eslint-disable-next-line no-console
                    console.log('W A R N I N G!!!!\nId ' + result.id + ' already exist!');
                }
                results.push(result);
            }
            if (lastItem === conf.blocks[lastBlock].items.length) {
                lastItem = 0;
                lastBlock++;
                if (lastBlock < conf.blocks.length) {
                    view.innerHTML = conf.blocks[lastBlock].content;
                    return;
                } else {
                    document.body.style.cursor = 'wait';
                    calcResult(successFn, errorFn);
                    return;
                }
            }
            let item = conf.blocks[lastBlock].items[lastItem];
            if (item.mime === 'image/svg+xml') {
                view.innerHTML = stripAndExecute(item.content);
            }
            lastItem++;
        },
        nextPage(config) {
            let delay = 0, tick, interval;
            if (config.counter) {
                delay = parseInt(config.counter.textContent);
                tick = delay;
                interval = window.setInterval(() => {
                    config.counter.textContent = --tick;
                }, 1000);
                window.setTimeout(() => {
                    window.clearInterval(interval);
                    if (conf.blocks[lastBlock].items[lastItem - 1].page2 || conf.blocks[lastBlock].items[lastItem - 1].page2.id === config.itemId) {
                        view.innerHTML = stripAndExecute(conf.blocks[lastBlock].items[lastItem - 1].page2.content);
                    }
                }, delay * 1000);
            } else {
                // eslint-disable-next-line no-console
                console.log('no counter passed!');
            }
        },
        canCommunicate() {
            return typeof window.XMLHttpRequest !== 'undefined' || typeof ActiveXObject !== 'undefined';
        },
        canShowSVG() {
            return !!(document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect);
        }
    }
}
window.PST = PST;
module.exports = PST;
